<script setup lang="ts">
    import { useField } from 'vee-validate';
    import type { ChangeEvent } from 'ant-design-vue/es/_util/EventInterface';

    const props = defineProps({
        inputName: {
            type: String,
            default: 'text',
        },
        prefixText: {
            type: String,
            default: '+63',
            required: false
        },
        placeholder: {
            type: String,
            default: '',
            required: false
        },
        class: {
            type: String,
            required: false
        },
        borderless: {
            type: Boolean,
            default: false,
            required: false
        }
    })

    // For settings the class depending on the prop.
    const classObject = computed(() => ({
        'border-none' : props.borderless == true,
    }))

    // const emit = defineEmits(['update:modelValue']);

    const updateValue = (event: ChangeEvent) => {
        setValue(event.target.value);
        // emit('update:modelValue', event.target.value);
    };

    const { value, setValue, errorMessage }: any = useField(() => props.inputName)
</script>

<template>
    <Block
        :class="[
        { 'is-invalid' : errorMessage },
        'flex justify-items-start py-[.4rem] px-[1.6rem] w-full',
        classObject,
        props.class,
    ]">
        <span class="flex items-center text-[1.4rem] font-bold text-[black] border-[0] border-r-[1px] pr-[1.2rem]">{{ prefixText }}</span>
        <a-input
            :class="[
                { 'is-invalid' : errorMessage },
                'pl-[1.2rem] pr-0 w-full text-[1.4rem] font-bold text-[darkGray] font-normal',
            ]"
            :placeholder="props.placeholder"
            :id="props.inputName"
            :name="props.inputName"
            :maxlength="10"
            :value="value"
              :bordered="false"
            :allowClear="true"
            @change="updateValue"
        >
        </a-input>
    </Block>
    <template v-if="errorMessage">
        <p class="text-[redError] text-[1.4rem] leading-[1.5] mt-[.4rem]">
        {{  errorMessage }}
        </p>
    </template>
</template>

